/*
 * The doors of the story's fourth step: the tools one answer is shown in.
 * Plain data, apart from the cards that draw it (connected-answer), so the
 * pricing page's tools row can be held to it: a tool the landing shows is a
 * tool the comparison names (pricing/pricing-model.test.ts).
 */

export const DOORS = [
  { id: "twin", name: "Twin chat", connection: "Shared context" },
  { id: "chatgpt", name: "ChatGPT", connection: "Via MCP" },
  { id: "claude", name: "Claude", connection: "Via MCP" },
  { id: "gemini", name: "Gemini", connection: "Via MCP" },
  // Twin is an agent inside Microsoft 365 Copilot (and Teams), from one
  // Microsoft 365 app, not an MCP connection; the card says the product's
  // full name, the tab its short one.
  { id: "copilot", name: "Microsoft 365 Copilot", tab: "Copilot", connection: "Twin agent" },
  { id: "terminal", name: "Terminal", connection: "Twin CLI" },
] as const;

export type Door = (typeof DOORS)[number];

/** The doors that are someone else's AI tool: every door but Twin's own chat and the terminal. */
export const THIRD_PARTY_TOOLS = DOORS.filter((door) => door.id !== "twin" && door.id !== "terminal");
